import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Card, F0Dialog } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'
import { UpsellLandingPage } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

const VideoModal = ({
  videoModal,
  onClose,
}: {
  videoModal: { isOpen: boolean; video: string }
  onClose: () => void
}) => {
  return (
    <>
      <F0Dialog isOpen={videoModal.isOpen} onClose={onClose} position="center" title="">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 z-[9999]  text-gray-800  rounded-full w-8 h-8 flex items-center justify-center shadow-lg border"
          aria-label="Close video"
          style={{
            zIndex: 9999,
            backgroundColor: 'white',
            opacity: 1,
            border: '1px solid #05234824',
          }}
        >
          <Cross className="w-4 h-4" />
        </button>

        <div className="relative w-full max-w-4xl">
          {/* Video Container */}
          <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
            <video
              src={videoModal.video}
              autoPlay
              muted
              loop
              style={{ width: '100%', height: '100%' }}
            />
          </div>
        </div>
      </F0Dialog>
    </>
  )
}

export const LaunchesWithCEOPageFeaturesSection = ({
  content,
}: {
  content: UpsellLandingPage | undefined
}) => {
  const [videoModal, setVideoModal] = useState({ isOpen: false, video: '' })
  const section = content?.sections?.at(0)

  const mediaImages = [
    'https://www.datocms-assets.com/58969/1761143039-one-promo-1.png',
    'https://www.datocms-assets.com/58969/1761143033-one-promo-2.png',
    'https://www.datocms-assets.com/58969/1761143026-one-promo-3.png',
  ]

  const videos = [
    'https://stream.mux.com/sYQFeATGB004IEW02QZOpIyqA1eVK9fmPe/high.mp4', // one-promo-questions.mp4
    'https://stream.mux.com/yIdS8giK5wwSbXpipYuwvp7d02T8imkd8/high.mp4', // one-promo-insights.mp4
    'https://stream.mux.com/9eyR01UigFPcivxcHY8stv8uKb6DZq020202/high.mp4', // one-promo-collaborate.mp4
  ]

  return (
    <>
      <Box className="gap-4">
        <Box className="mb-4 text-center">
          <Text size="500" color="black" weight="bold">
            {section?.title || ''}
          </Text>
          <Text size="400">{section?.description || ''}</Text>
        </Box>
        <Box className="grid grid-cols-3 gap-4 " paddingRight="s80" paddingLeft="s80">
          {section?.features?.map((feature, index) => (
            <F0Card
              key={index}
              image={mediaImages[index]}
              title={feature.title || ''}
              description={feature.description || ''}
              secondaryActions={[
                {
                  label: section.buttonLabel || '',
                  onClick: () => {
                    track(trackingEvents.upsell.clickHowButtonPromoSection, {
                      component: 'launches_with_ceo_features_section',
                      index: index,
                    })
                    setVideoModal({ isOpen: true, video: videos[index] || '' })
                  },
                },
              ]}
            />
          ))}
        </Box>
      </Box>
      <VideoModal
        videoModal={videoModal}
        onClose={() => {
          setVideoModal({ isOpen: false, video: '' })
        }}
      />
    </>
  )
}
